import { createSlice } from "@reduxjs/toolkit";

const attendanceSlice = createSlice({
    name:"attendance",
    initialState:{
        userCheckIn: null ,
        userCheckOut: null,
        yesterdayAttendance: null,
        attendanceReport: [],
        loading:false,
        error: null,
       
    }, 

    reducers:{
        startLoading(state) {
            state.loading = true;
            state.error = null;
          },
          stopLoading(state) {
            state.loading = false;
          },
      setUserCheckIn(state, action){
        state.userCheckIn = action.payload
      },
      setUserCheckOut(state,action){
        state.userCheckOut = action.payload
      },
      clearAttendance(state){
        state.userCheckIn = null ;
        state.userCheckOut = null;
      }, 
      setYesterdayAttendance(state,action){
        state.yesterdayAttendance = action.payload
      },
      setAttendanceReport(state,action){
        state.attendanceReport = action.payload
      },
      setError(state , action){
        state.error = action.payload;
        state.loading = false;
      },
      clearAttendanceReport(state) {
        state.attendanceReport = [];
      },



    }
});


const attendanceReducer = attendanceSlice.reducer;
const attendanceActions = attendanceSlice.actions;

export {attendanceActions , attendanceReducer}